<!--
 * @description: 主菜单-页头（顶部-信息）
 * @Author: Jay
 * @Date: 2026-03-02 10:48:44
 * @LastEditors: Jay
 * @LastEditTime: 2026-03-02 13:38:55
-->
<template>
  <div>
    <div class="flex align-center margin-tb-xs gesture-pointer">
      <div
        class="flex align-center text-size"
        v-for="(item, index) in matchedList"
        :key="index"
      >
        <el-image
          class="menu-img"
          :src="item.meta.iconImg"
          v-if="item.meta.iconImg != '' && index == 0"
          fit="fill"
        ></el-image>
        <p class="margin-lr-x text-gray">/</p>
        <p
          :class="
            index === matchedList.length - 1 ? 'line2-color' : 'line-color'
          "
        >
          {{ item.meta.title }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 页面标题
      pageTitle: "",
      // 路由信息/面包屑
      matchedList: [],
    };
  },
  created() {
    // console.log(this.$route, "页面标题--");
    // 页面标题
    this.pageTitle = this.$route.name || "";
    // 路由信息/面包屑
    this.matchedList = this.$route.matched || [];
    // 过滤一个首页
    this.getBreadcrumb();
  },
  methods: {
    // 过滤一个首页
    getBreadcrumb() {
      // this.$route.matched匹配到一个路由数组
      let matched = this.$route.matched.filter(
        (item) => item.meta && item.meta.title,
      );

      const first = matched[0];
      if (!this.isHome(first)) {
        // 过滤一个首页
        matched = matched.filter((item, index, self) => {
          // 使用 filter 方法进行筛选，只保留第一个出现的相同 value 的元素
          return self.findIndex((obj) => obj.name === item.name) === index;
        });
      }
      this.matchedList = matched.filter((item) => item.meta && item.meta.title);
    },
    // 判断是否为主页
    isHome(route) {
      const name = route && route.name;
      if (!name) {
        return false;
      }
      // 对路由进行大小写处理
      return name.trim().toLocaleLowerCase() === "/home".toLocaleLowerCase();
    },
  },
  //   watch: {
  //     // 监听 路由信息/面包屑
  //     matchedList: {
  //       handler(newVal, oldVal) {
  //         console.log(newVal, oldVal);
  //       },
  //       deep: true,
  //     },
  //   },
};
</script>

<style lang="scss" scoped>
// 顶部导航图标
.menu-img {
  width: 15px;
  height: 15px;
  padding: 3px;
  background-color: #78808c;
  border-radius: 50%;
}

.text-size {
  font-size: 14px;
}

.line-color {
  color: #78808c;
}

.line2-color {
  color: #1d2129;
  font-weight: 700;
}
</style>
